import React, { useState, useRef, useEffect } from "react";
import TransferReceiverSelectComponent from "./transferReceiverSelect.component";
import { selectLoading } from "modules/notification";
import TransferReceiverSelectPanelComponent from "./transferReceiverSelectPanel.component";
import { getTransferReceiverDropdown } from "modules/stockflow/redux";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";
import customFeatureApi from "app/api/customFeature/prife";

function TransferReceiverSelectContainer({
  handleChange,
  disabled,
  value,
  styles,
  textStyles,
  placeholder,
  companyId,
}) {
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransferReceiverDropdown.typePrefix)
  );
  const transferReceiverDropdown = useSelector(
    (state) => state.stockflowTransfer.transferReceiverDropdown
  );
  const lang = useSelector((state) => state.constant.languages);
  const prifeCompanyList = [57, 85, 108];
  const isPrifeCompany = prifeCompanyList.includes(companyId);
  const [prifeReceiverDropdown, setPrifeReceiverDropdown] = useState([]);
  const [isPrifeFetching, setIsPrifeFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (isPrifeCompany) {
      setIsPrifeFetching(true);
      customFeatureApi
        .getPrifeReceiveTransferReceiverDropdown({ search })
        .then((res) => {
          const data = res?.data ?? res;
          setPrifeReceiverDropdown(Array.isArray(data) ? data : []);
        })
        .catch(() => setPrifeReceiverDropdown([]))
        .finally(() => setIsPrifeFetching(false));
    } else {
      dispatch(getTransferReceiverDropdown({ search }));
    }
  }, [search, dispatch, isPrifeCompany]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    const dropdown = isPrifeCompany
      ? prifeReceiverDropdown
      : transferReceiverDropdown;
    setSelectAll(value.length === dropdown.length);
  }, [value, transferReceiverDropdown, prifeReceiverDropdown, isPrifeCompany]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleSelectAll = async () => {
    const dropdown = isPrifeCompany
      ? prifeReceiverDropdown
      : transferReceiverDropdown;
    if (!selectAll) {
      const selectedReceiver = dropdown.map((p) => p.uuid);
      handleChange(selectedReceiver);
    } else {
      handleChange([]);
    }
  };

  const handleSelectReceiver = (receiver) => {
    let temp = cloneDeep(value);

    if (temp.findIndex((t) => t === receiver.uuid) >= 0) {
      temp = temp.filter((t) => t !== receiver.uuid);
    } else {
      temp.push(receiver.uuid);
    }
    handleChange(temp);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <>
      <TransferReceiverSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <TransferReceiverSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isPrifeCompany ? isPrifeFetching : isFetching}
        transferReceiverDropdown={
          isPrifeCompany ? prifeReceiverDropdown : transferReceiverDropdown
        }
        handleSelectAll={handleSelectAll}
        handleSelectReceiver={handleSelectReceiver}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

export default TransferReceiverSelectContainer;
